import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { ThemesService } from './themes.service';

export function provideTheming(): EnvironmentProviders[] {
  return [
    provideAppInitializer(() => {
      const themesService = inject(ThemesService);

      themesService.initialize();
    }),
  ];
}
